module.exports = __webpack_public_path__ + "static/media/fushia-preview.6f49c62b.svg";